// extracted by mini-css-extract-plugin
export default {"title":"SendingNDACheckboxField_title__trbTY","tooltipTitle":"SendingNDACheckboxField_tooltipTitle__yOJrx"};